import React, { useEffect, useState } from 'react';
import { useAuth } from './context/AuthContext';
import LoginScreen from './components/LoginScreen';
import ChatScreen from './components/ChatScreen';
// 1. Importar el CSS de react-toastify
import 'react-toastify/dist/ReactToastify.css';
// 2. Importar el componente ToastContainer y el objeto toast
import { ToastContainer } from 'react-toastify';
const THEME_MAP: { [key: string]: string } = {
  "IA Tributario/Contable | Algortimo Jurídico SAC": "theme-tributario",
  "IA Civil | Algortimo Jurídico SAC": "theme-civil",
  "IA Penal | Algortimo Jurídico SAC": "theme-penal",
  "IA Laboral | Algortimo Jurídico SAC": "theme-laboral"
  // Puedes añadir más mapeos aquí para otros productos
};
function App() {
  const { isAuthenticated, logout } = useAuth();
  console.log(`Inciando el Tema`);
  useEffect(() => {
    // 1. Leer la variable de entorno
    const websiteTitle = process.env.REACT_APP_WEBSITE_TITLE;
    // 2. Encontrar el tema correspondiente en nuestro mapeador
    const themeClass = websiteTitle ? THEME_MAP[websiteTitle] : null;
    // 3. Limpiar clases de tema anteriores por si acaso
    document.body.classList.remove('theme-legal', 'theme-corporate');
    // Luego, añadimos la clase del nuevo tema si no es el default
    if (themeClass) {
      document.body.classList.add(themeClass);
      console.log(`Tema aplicado: ${themeClass}`);
    } else {
      console.log("No se encontró un tema específico, usando el tema por defecto.");
    }
  }, []);

  return (
    <div className="App">
      {isAuthenticated ? (
        <ChatScreen onLogout={logout} />
      ) : (
        <LoginScreen />
      )}
      <ToastContainer
        position="bottom-right" // Posición de las notificaciones
        autoClose={5000} // Se cierran automáticamente después de 5 segundos
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark" // El tema oscuro se ve genial con tu diseño
      />
    </div>
  );
}

export default App;